import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { PatientReg } from "app/shared/models/patient-reg.model";

export class SetPatientReg implements ReduxAction {
  type: string = "SET_PATIENT_REG";
  patientReg: PatientReg;

  constructor(patientReg: PatientReg) {
    this.patientReg = patientReg;
  }

  get() {
    return this.patientReg;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/actions/patient-reg.action.ts